module.exports = __webpack_public_path__ + "img/thumbnail_9.cab5f887.png";